import React from "react";
// Data
import awardData from "@/i18n/json/awards/data.json";
// Interface
import {IAwardsContent} from "@/components/awards/interfaces";
import {Trans, useTranslation} from "react-i18next";
import {
    container,
    wrapper,
    awardImage,
    awardHeading,
    awardLink,
    noLink,
    awardDate,
    awardDescription, background, spacing,
} from "@/components/awards/styles/award-list";

const AwardsContent: React.FC<IAwardsContent> = () => {
    const {t} = useTranslation();

    return (
        <section className={background}>
            {awardData["award-list"].awards.map((item: IAwardsContent, index: number) => {
                return (
                    <section key={index} className={container}>
                        <div className={awardImage}>
                            <img src={`/assets/images/awards/${item.img}`} alt={item.alt} title={item.title}/>
                        </div>

                        {/*If empty url show no link on heading*/}
                        <div className={wrapper}>
                            {item.url !== "" ? <a href={item.url} target={"_blank"} className={awardHeading}>{item.heading}</a> : <a className={awardHeading}>{item.heading}</a> }

                            {/*If empty url show no link*/}
                            {item.url !== "" ?
                                <a href={item.url} target={"_blank"} className={awardLink}>{item.site}</a> :
                                <a className={noLink}>{item.site}</a>}

                            <p className={awardDate}>{item.date}</p>

                            <p className={awardDescription}>{item.description}</p>
                        </div>
                    </section>)
            })}
            <p className={spacing}>.</p>
        </section>

    )
}

export default AwardsContent
